import React from 'react';

const ModalLoading = () => (
  <div className="modal-skp modal-skp--loading">
    <div className="modal-skp__content modal-skp__content--transparent">
      <div className="modal-skp__spinner" />
    </div>
  </div>
);

export default ModalLoading;



// WEBPACK FOOTER //
// ./src/components/ModalLoading/ModalLoading.js